var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"code-content-menu-items",style:({
    aspectRatio:
      _vm.blok.content[0].component === 'video-player'
        ? _vm.blok.content[0].aspectRatio
        : '16/9',
  })},_vm._l((_vm.blok.content),function(blok){return _c('StoryblokComponent',{key:blok._uid,attrs:{"blok":blok}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }